import React from 'react';
import { e4Format, e4Formats } from 'helpers/dates';
import { StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import { assetIcon } from 'components/general/assets';

export const Card = ({ children, addItemHandler, title, label, name, date, summary }) => (
    <div data-testid="card-wrapper">
        <div className={`flex pitch-card pointer`} title={title} onClick={addItemHandler}>
            <div className="media-holder">{children}</div>
            <div className="details-holder flex-grow">
                <div>
                    <label>{label}</label>
                </div>
                {name && (
                    <div className="flex flex-center text-sm">
                        <i className="fa fa-user mr5" />
                        {name}
                    </div>
                )}
                {date && (
                    <div className="flex flex-center text-sm">
                        <i className="fa fa-calendar mr5" />
                        {e4Format(date)}
                    </div>
                )}
                {summary && <div className="flex flex-center text-sm">{summary}</div>}
            </div>
        </div>
    </div>
);

export const ItemList = ({ label, items = [], onClickHandler, ...extraProps }) => (
    <div data-testid="item-list-wrapper" className="mt20" {...extraProps}>
        <label>{StringHelpers.pluralise(label, items?.length)}</label>
        {items
            ?.sort((a, b) => (a?.source > b?.source ? 1 : -1))
            .map((u, i) => {
                const icon = assetIcon({ ...u, source: u?.source?.includes('content') ? u.source : `content-${u.source}` });
                return (
                    <div key={`file-${i}`} className="mb5 flex flex-center">
                        <i className={`fa fa-${icon} })} mr5`} />
                        <span className="ellipsis500 flex-grow">{u.name}</span>
                        <i
                            data-testid={u?.name}
                            className="ml5 text-danger fa fa-trash pointer text-right"
                            title={SystemText('Admin/Forms/FilePicker/Content/ItemList/Icon/Title', u?.name)}
                            onClick={() => onClickHandler(u)}
                        />
                    </div>
                );
            })}
    </div>
);
